import { useMemo } from 'react';
import useQuery from '../../../../../../hooks/useQuery';
import { DeliveryModes } from '../../../types';

export default function useSemiPresentialDeliveryMode() {
  const query = useQuery();
  const deliveryMode = query.get('deliveryMode');

  const isSemiPresentationDeliveryMode = useMemo(() => {
    return deliveryMode === DeliveryModes.SP;
  }, [deliveryMode]);

  return {
    isSemiPresentationDeliveryMode,
  };
}
